import { render, staticRenderFns } from "./LossOfVerticalityConfig.vue?vue&type=template&id=6273cdc3&"
import script from "./LossOfVerticalityConfig.vue?vue&type=script&lang=ts&"
export * from "./LossOfVerticalityConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports